<app-modal-template
  [title]="'How would you like to use Google Slides?' | translate"
  [hasCloseButton]="true"
  [size]="PencilModalSizeEnum.LARGE"
  (closeButtonClicked)="onCancel()"
>
  <div content-description class="slides-mode-dialog__body">
    <div class="slides-mode-dialog__card" (click)="onSelectMode(SlidesImportMode.Present)">
      <svg-icon
        class="slides-mode-dialog__card-illustration"
        [icon]="'present_slides'"
        [width]="100"
        [height]="100"
      ></svg-icon>
      <div class="slides-mode-dialog__card-text">
        <h3 class="slides-mode-dialog__card-title">{{ 'Present to everyone' | translate }}</h3>
        <p class="slides-mode-dialog__card-subtitle">
          {{ 'Everyone sees the same view at the same time' | translate }}
        </p>
      </div>
      <div class="slides-mode-dialog__card-note">
        <p>
          {{ 'Set slides access to "' | translate
          }}<strong>{{ 'Anyone with the link' | translate }}</strong
          >{{ '" to present to everyone.' | translate }}
        </p>
      </div>
    </div>
    <div class="slides-mode-dialog__card" (click)="onSelectMode(SlidesImportMode.Collaborate)">
      <svg-icon
        class="slides-mode-dialog__card-illustration"
        [icon]="'collaborate_slides'"
        [width]="100"
        [height]="100"
      ></svg-icon>
      <div class="slides-mode-dialog__card-text">
        <h3 class="slides-mode-dialog__card-title">{{ 'Work on slides together' | translate }}</h3>
        <p class="slides-mode-dialog__card-subtitle">
          {{ 'People can work independently on the app' | translate }}
        </p>
      </div>
      <div class="slides-mode-dialog__card-note">
        <p>{{ 'Slides will only be visible to people who have access to them.' | translate }}</p>
      </div>
    </div>
  </div>
</app-modal-template>
